import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, Routes } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs/Subscription";
import { AuthService } from "./auth/auth.service";
import { SendEventGoogleService } from "./utils/google/sendEventGoogle.service";
import {filter} from 'rxjs/operators';

declare var gtag;

@Component({
  selector: "app-my-app",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private sendEventGoogle: SendEventGoogleService,
    private translateService: TranslateService
  ) {
    const navEndEvents = router.events.pipe(filter(event => event instanceof NavigationEnd));
    navEndEvents.subscribe((event: NavigationEnd) => {
      gtag('config', 'UA-157141987-1', {
        'page_path': event.urlAfterRedirects
      });
    });
  }

  private ROUTES: Routes

  ngOnInit() {
    const language = localStorage.getItem('language');
    if (language) this.translateService.use(language);

    const storageRoutes = localStorage.getItem("routes");

    if (storageRoutes) this.ROUTES = JSON.parse(storageRoutes);
    
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe(_=> {
        const body = document.getElementsByTagName("body")[0];
        const modalBackdrop = document.getElementsByClassName("modal-backdrop")[0];
        if (body.classList.contains("modal-open")) {
          body.classList.remove("modal-open");
          modalBackdrop.remove();
        }
        this.sendEventGoogle.trackPageView();
      });
    this.authService.autoLogin();
  }
}
